import { render, staticRenderFns } from "./AddedChanges.vue?vue&type=template&id=0697bc9e&"
import script from "./AddedChanges.vue?vue&type=script&lang=js&"
export * from "./AddedChanges.vue?vue&type=script&lang=js&"
import style0 from "./AddedChanges.vue?vue&type=style&index=0&id=0697bc9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports